export default __webpack_public_path__ + "static/banner-fullstack-f0c73d21892b299e015fbcf10e99cebf.jpg";